<iv-live-summary-line
  *ngIf="!fs()"
  [hv]="hv"
  [(isClose)]="isClose"
  [ivx]="ivx"
  (hvChange)="changeHv($event)"
  (ivxChange)="changeIvx($event)"
  [hasOptions]="instrument?.hasOptions"
  [hideCharts]="hideCharts"
  [instrument]="instrument"
  (HVInit)="HV = $event"
  (IVXInit)="IVX = $event"
  (stockInfoChanged)="stockInfo = $event"
>
</iv-live-summary-line>

<iv-live-x30-chart
  *ngIf="!hideCharts"
  [datafeedUrl]="ivx30Url"
  [style.height]="chartHeight"
  [hideCharts]="hideCharts"
  [hv]="hv"
  [ivx]="ivx"
  (hvChange)="changeHv($event)"
  (ivxChange)="changeIvx($event)"
  [marketClose]="isClose"
  [noOptions]="noOptions"
  [symbol]="instrument"
  class="ivx30-chart"
></iv-live-x30-chart>

<div
  (mousedown)="onMouseDown()"
  *ngIf="instrument.hasOptions && !fs()"
  [class.movable]="!hideCharts"
  class="splitter"
>
  <button
    statistic
    statisticElementName="Click Tradingview hide chart"
    (click)="onToggle($event)"
    [class.expand]="hideCharts == true"
    class="iv-inline-button iv-inline-button_toggle"
    style="height: auto;"
  >
    <i class="material-icons"></i>
  </button>
</div>

<div
  class="option-monitor"
  #service
  *ngIf="instrument.hasOptions && !fs()"
>
  <iv-live-option-monitor
    [HV]="HV"
    [IVX]="IVX"
    [stockInfo]="stockInfo"
    [hasOptions]="instrument?.hasOptions"
    [hideCharts]="hideCharts"
  ></iv-live-option-monitor>
</div>
